/**
 * Applies CSS custom properties to skeleton elements from data attributes.
 * 
 * NOTE: element.style.setProperty() for CSS custom properties is CSP-compliant.
 * CSSOM operations like setProperty() are allowed by CSP policy style-src 'self'.
 * This is the recommended approach for dynamic CSS variables that can't be mapped to utility classes.
 */

/**
 * Applies skeleton styles to elements within the given scope
 * @param {HTMLElement|Document} scope - The element or document to search within
 */
function applySkeletonStyles(scope = document) {
  // If scope is a skeleton element itself, apply styles to it
  if (scope.classList && scope.classList.contains('skeleton')) {
    const el = scope;
    if (el.dataset.rectH) el.style.setProperty('--rect-h', el.dataset.rectH);
    if (el.dataset.lines) el.style.setProperty('--lines', el.dataset.lines);
    if (el.dataset.cW) el.style.setProperty('--c-w', el.dataset.cW);
    if (el.dataset.lH) el.style.setProperty('--l-h', el.dataset.lH);
    if (el.dataset.cP) el.style.setProperty('--c-p', el.dataset.cP);
    if (el.dataset.bg) el.style.setProperty('--bg', el.dataset.bg);
    return;
  }
  
  // Otherwise, search for skeleton elements within the scope
  scope.querySelectorAll('.skeleton[data-rect-h], .skeleton[data-lines], .skeleton[data-c-w], .skeleton[data-l-h], .skeleton[data-c-p], .skeleton[data-bg]').forEach(function(el) {
    if (el.dataset.rectH) el.style.setProperty('--rect-h', el.dataset.rectH);
    if (el.dataset.lines) el.style.setProperty('--lines', el.dataset.lines);
    if (el.dataset.cW) el.style.setProperty('--c-w', el.dataset.cW);
    if (el.dataset.lH) el.style.setProperty('--l-h', el.dataset.lH);
    if (el.dataset.cP) el.style.setProperty('--c-p', el.dataset.cP);
    if (el.dataset.bg) el.style.setProperty('--bg', el.dataset.bg);
  });
}

// Apply to existing elements on page load
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', function() {
    applySkeletonStyles();
  });
} else {
  applySkeletonStyles();
}

// Make function available globally for dynamically added elements
if (typeof window !== 'undefined') {
  window.applySkeletonStyles = applySkeletonStyles;
}

export { applySkeletonStyles };
